import { render, staticRenderFns } from "./DialogPageChat.vue?vue&type=template&id=8f706f9c"
import script from "./DialogPageChat.vue?vue&type=script&lang=js"
export * from "./DialogPageChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports